import * as constants from './constants';
import { createReducer } from '../../utils';
import initialState from './initialState';

export default createReducer(initialState, {
  [constants.GOOGLE_CALENDAR_SELECTED]: (state, payload) => ({
    ...state, selected: payload.selected,
  }),
});
